import React from 'react'
import MovieSearchFormContainer from '../../MovieSearchForm/MovieSearchFormContainer'


const OverviewSearchContainer = ({
    queryStringValues,
    translation,
}) => {    
    const isOpen = queryStringValues.search || (queryStringValues.searchopen && '1' === queryStringValues.searchopen)

    return (
        isOpen ? <div className='overview-search-container'>
            <MovieSearchFormContainer
                textClass="text-light"
                translation={translation}
            />
        </div> : ''
    )
}

export default OverviewSearchContainer